"use client";

import { GripVertical } from "lucide-react";
import Image from "next/image";
import {
	ReactCompareSlider,
	ReactCompareSliderHandle,
} from "react-compare-slider";

interface ImageCompareItemProps {
	beforeSrc: string;
	afterSrc: string;
	altBefore?: string;
	altAfter?: string;
	mode?: "comparison" | "single";
	singleImageKey?: "before" | "after";
}

export function ImageCompareItem({
	beforeSrc,
	afterSrc,
	altBefore = "Before image",
	altAfter = "After image",
	mode = "comparison",
	singleImageKey = "after",
}: ImageCompareItemProps) {
	if (mode === "single") {
		const imageSrc = singleImageKey === "before" ? beforeSrc : afterSrc;
		const imageAlt = singleImageKey === "before" ? altBefore : altAfter;

		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					borderRadius: "0.5rem",
					overflow: "hidden",
				}}
			>
				<Image
					src={imageSrc || "/placeholder.svg"}
					alt={imageAlt}
					width={800}
					height={600}
					className="object-cover w-full h-full"
					priority
				/>
			</div>
		);
	}

	return (
		<ReactCompareSlider
			boundsPadding={0}
			itemOne={
				<Image
					src={beforeSrc || "/placeholder.svg"}
					alt={altBefore}
					width={800}
					height={600}
					className="object-cover w-full h-full"
					priority
				/>
			}
			itemTwo={
				<Image
					src={afterSrc || "/placeholder.svg"}
					alt={altAfter}
					width={800}
					height={600}
					className="object-cover w-full h-full"
					priority
				/>
			}
			handle={
				<ReactCompareSliderHandle
					buttonStyle={{
						backdropFilter: undefined,
						WebkitBackdropFilter: undefined,
						backgroundColor: "hsla(0, 0%, 100%, 0.3)",
						border: "none",
						boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
						color: "#333",
						height: 40,
						width: 40,
					}}
					linesStyle={{
						opacity: 0.5,
					}}
				>
					<GripVertical size={24} />
				</ReactCompareSliderHandle>
			}
			style={{
				width: "100%",
				height: "100%",
				borderRadius: "0.5rem",
				overflow: "hidden",
			}}
		/>
	);
}
